import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import ServiceArea from "../../../components/ServiceArea/ServiceArea.js";
import Skeleton from '@material-ui/lab/Skeleton';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import API from '../../../api/api';
import { getImageUrl } from '../../../utils/imageUtils';
import { sortServices } from '../../../content/servicesCatalog';

const garageApi = new API();

export default function ServiceSection(props) {

  const [services, setServices] = useState([]);
  const [snackBar, setSnackBar] = useState(false);
  const [loadingServices, setLoadingServices] = useState(false);

  useEffect(() => {

    garageApi.openEndpoints.services.getAll()
      .then((servicesGET) => {
        try
        {
          let services = [];
          if (servicesGET && servicesGET.data) {
            if (Array.isArray(servicesGET.data)) {
              services = servicesGET.data;
            } else if (servicesGET.data.results && Array.isArray(servicesGET.data.results)) {
              services = servicesGET.data.results;
            }
          }

          setServices(sortServices(services));
          setLoadingServices(true);
        }
        catch(e)
        {
          console.error('Error parsing services:', e);
          setServices([]);
          setSnackBar(true);
        }
      })
      .catch((error) => {
        console.error('Error loading services:', error);
        setServices([]);
        setLoadingServices(true);
      });

  }, []);

  function closeSnackBar (event, reason)
  {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBar(false);
  }

  return (
    <section className="spg-section">
      <Snackbar open={snackBar} autoHideDuration={6000} onClose={closeSnackBar}>
        <MuiAlert elevation={6} variant="filled" onClose={closeSnackBar} severity="warning" >Server Fehler 500</MuiAlert>
      </Snackbar>
      <div className="spg-kicker">Werkstatt</div>
      <h2 className="spg-title">Dienstleistungen</h2>
      <p className="spg-lead">
        Fokus auf VW, Audi, SEAT, Škoda &amp; CUPRA – plus Pannendienst, Carrosserie, Lack und mehr.
      </p>
      <RouterLink className="spg-btn-outline" to="/dienstleistungen" style={{ marginTop: 16, display: 'inline-flex' }}>
        Alle Leistungen ansehen
      </RouterLink>
      <div className="spg-grid is-services" style={{ marginTop: 36 }}>

          { loadingServices ?
            <>
              { Array.isArray(services) && services.length > 0 ? services.map(function(service, index){
                return (
                  <ServiceArea
                    key={service.unikey}
                    index={index}
                    linkKey={service.unikey}
                    title={service.title}
                    description={service.description}
                    image={service.image ? getImageUrl(service.image, 'medium') || '' : ''}
                  />
                )
               }) : (
                <p className="spg-lead">Bald finden Sie hier unsere Leistungen – oder direkt im Admin anlegen.</p>
               )}
             </>
            :
            Array.from({ length: 3 }, (_, i) =>
              <ServiceArea
                key={i}
                title={<Skeleton variant="text" width={'100%'} />}
                description={<Skeleton variant="rect" width={'100%'} height={118} />}
                image={<Skeleton variant="circle" width={100} height={100} />}
              />
            )
          }
      </div>
    </section>
  );
}
